import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import AuthShell from '../components/AuthShell';

const NotFound: React.FC = () => {
  const { user } = useAuth();

  return (
    <AuthShell brandAsHeading={false}>
      <div className="text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-50 text-blue-600 dark:bg-blue-950/60 dark:text-blue-400">
          <Compass className="w-6 h-6" />
        </div>
        <p className="eyebrow mb-1">Error 404</p>
        <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white mb-2">Page Not Found</h1>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">
          This page doesn't exist. If someone sent you a class link, check that it was copied completely.
        </p>
        <Link to={user ? '/dashboard' : '/login'} className="btn btn-primary btn-lg w-full sm:w-auto">
          {user ? 'Back to Dashboard' : 'Go to Login'}
        </Link>
      </div>
    </AuthShell>
  );
};

export default NotFound;
